export default {
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    configureList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      form: {}
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form = this.styleObj;
    });
  },
  methods: {
    changeFun(mark, id) {
      this.form.controlsComponentsMark = mark;
      this.form.controlsComponentsId = id;
      this.changeForm();
    },
    changeForm() {
      this.$emit('itemChange', this.form);
    }
  }
};